<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <div class="c-avatar">
          <img
            src="img/avatars/bluestar-drop.jpg"
            class="c-avatar-img "
          />
        </div>
      </CHeaderNavLink>
    </template>
    <CDropdownHeader tag="div" class="text-center" color="light">
      <strong>Account</strong>
    </CDropdownHeader>
    <CDropdownItem @click="goToProfile()">
      <CIcon name="cil-user" /> Profile
    </CDropdownItem>
    <CDropdownItem @click="logout()">
      <CIcon name="cil-lock-locked" /> Logout
    </CDropdownItem>
  </CDropdown>
</template>

<script>
import axios from 'axios';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'TheHeaderDropdownAccnt',
  data () {
    return { 
      itemsCount: 42,
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.currentUser,
      token: state => state.token
    })
  },
  methods:{
    ...mapActions(['resetState']),
    logout() {
      const token = this.token === null ? localStorage.getItem("api_token") : this.token;
      const url = `/api/logout?token=${token}`;
      axios.post(url,{})
      .then(response => {
        this.resetState();
        this.$router.push({ path: '/login' });
      }).catch(error => {
        console.log(error); 
      });
    },
    goToProfile() {
      const user = JSON.parse(this.currentUser);
      this.$router.push({ name: 'Profile', params: { id: user.id } });
    }
  }
}
</script>
<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>
